import { render } from "./EventCard.vue?vue&type=template&id=193dee99&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=193dee99&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193dee99"]])

export default __exports__